export enum ShowBasketButtonType {
    None = 'None',
    LineCount = 'LineCount',
    ItemsCount = 'ItemsCount',
}
